// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`PaymentEditModal general snapshot 1`] = `
<div class="dashboard-inner narrow-modal-body">
  <sectiontitle-stub text="Add Payment Method" data-mr-ass="add-payment-method-modal" class="app-modal-title"></sectiontitle-stub>
  <form></form>
  <!---->
  <!---->
  <form>
    <div class="row">
      <paymenteditinputs-stub v="[object Object]"></paymenteditinputs-stub>
    </div>
    <div class="row">
      <addresseditinputs-stub v="[object Object]"></addresseditinputs-stub>
    </div>
    <div class="row">
      <submitbuttons-stub submittext="Save" submitmethod="function () { [native code] }" submitvisible="true" submitclass="" canceltext="Cancel" cancelmethod="function () { [native code] }" cancelvisible="true"></submitbuttons-stub>
    </div>
  </form>
</div>
`;
